<template>
  <div style="width: calc(100% - 200px); margin:auto;">
    <StoryList v-if="$route.path === '/recruits/story'" :PCTRLLOG="CTRLLOG"/>
    <StoryEdit v-if="$route.path.indexOf('recruits/storyedit') >= 0"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StoryList      from '@/views/DashBoard/Story/StoryList'
import StoryEdit      from '@/views/DashBoard/Story/StoryEdit'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'RecruitStory',
  componentName: 'RecruitStory',
  components: {
    StoryList,
    StoryEdit
  },
  mixins: [
    controlLogMixin
  ],
  created() {
    this.$store.dispatch('chatbot/getStory')
  },
  data () {
    return {
      COMPONENT_NAME: 'RecruitStory',
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/RecruitStory.vue